/**
 * @module environmental - helper function for environmental behaviors.
 */

const defaultAtmosphericMillibars = 1013.25;

/**
  * @function saturationVaporPressure - calculate saturation vapor pressure.
  * @param celsius - temperature in celsius.
  */
exports.saturationVaporPressure = celsius => {
  const pressure = 6.112 * Math.exp(17.67 * celsius / (243.5 + celsius));
  return pressure;
};

/**
  * @function saturation - calculate saturation.
  * @param dryCelsius - dry bulb temperature in celsius.
  * @param wetCelsius - wet bulb temperature in celsius.
  * @param atmosphericMillibars - atmospheric pressure in millibars.
  */
exports.saturation = function (dryCelsius, wetCelsius) {
  let atmosphericMillibars = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultAtmosphericMillibars;
  const wetPressure = exports.saturationVaporPressure(wetCelsius);
  return wetPressure - 0.00066 * (1 + 0.00115 * wetCelsius) * (dryCelsius - wetCelsius) * atmosphericMillibars;
};

/**
  * @function relativeHumidity - calculate relative humidity.
  * @param dryCelsius - dry bulb temperature in celsius.
  * @param wetCelsius - wet bulb temperature in celsius.
  * @param atmosphericMillibars - atmospheric pressure in millibars.
  */
exports.relativeHumidity = function (dryCelsius, wetCelsius) {
  let atmosphericMillibars = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultAtmosphericMillibars;
  const dryPressure = exports.saturationVaporPressure(dryCelsius);
  const saturation = exports.saturation(dryCelsius, wetCelsius, atmosphericMillibars);
  let percentHumidity = 100 * (saturation / dryPressure);
  if (percentHumidity < 0 || percentHumidity > 100) {
    percentHumidity = undefined;
  }
  return percentHumidity;
};

/**
  * @function dewPoint - calculate dew point
  * @param dryCelsius - dry bulb temperature in celsius.
  * @param relativeHumidity - relative humidity.
  * @param atmosphericMillibars - atmospheric pressure in millibars.
  */
exports.dewPoint = (dryCelsius, relativeHumidity) => {
  const dryPressure = exports.saturationVaporPressure(dryCelsius);
  const saturation = relativeHumidity / 100 * dryPressure;
  const b = Math.log(saturation / 6.108) / 17.27;
  return 237.3 * b / (1 - b);
};

/**
  * @function celsiusFromFahrenheit - converts temperature
  * @param fahrenheit - temperature in fahrenheit.
  * @returns temperature in celsius.
  */
exports.celsiusFromFahrenheit = fahrenheit => (fahrenheit - 32) * 5 / 9;

/**
  * @function fahrenheitFromCelsius - converts temperature
  * @param celsius - temperature in celsius.
  * @returns temperature in fahrenheit.
  */
exports.fahrenheitFromCelsius = celsius => celsius * 9 / 5 + 32;